import { AamiFonts, ApiaFonts, FoundationFonts, GuFonts, ImanFonts, IngFonts, NavigatorFonts, NibFonts, NsiFonts, NibLegacyFonts, QantasFonts, SuncorpFonts, TalFonts, WorldNomadsFonts, CotaFonts, AustralianSeniorsFonts, RealFonts, AanzFonts, EdiFonts, TidFonts } from "@nib/fonts";
export var brandFonts = {
  nib: NibFonts,
  aami: AamiFonts,
  apia: ApiaFonts,
  ing: IngFonts,
  suncorp: SuncorpFonts,
  navigator: NavigatorFonts,
  foundation: FoundationFonts,
  qantas: QantasFonts,
  gu: GuFonts,
  tal: TalFonts,
  iman: ImanFonts,
  priceline: null,
  // No web fonts
  nibLegacy: NibLegacyFonts,
  worldNomads: WorldNomadsFonts,
  nsi: NsiFonts,
  cota: CotaFonts,
  australianSeniors: AustralianSeniorsFonts,
  real: RealFonts,
  aanz: AanzFonts,
  edi: EdiFonts,
  tid: TidFonts
};